import { NavLink, useParams } from 'react-router-dom';

import { RegistrantFilter } from '@/types/registration.types';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import Text from '@ui/text/text/text';
import { ICONS } from '@ui/icons/types';
import useGetDisplayProjectName from '@/utils/use-get-display-project-name';

import styles from '../passcode-lists/add-new-passcode-list-card.module.css';

type RegistrantFilterCardLargeProps = {
  filter: RegistrantFilter;
};

const RegistrantFilterCardLarge = ({ filter }: RegistrantFilterCardLargeProps) => {
  const { projectUuid, language } = useParams();
  const projectName = useGetDisplayProjectName();

  return (
    <NavLink
      to={`/project/edit/${projectUuid}/${language}/audiences/registrants?status=${filter.type}`}
      className={styles['passcode-list-edit']}
      style={{ textDecoration: 'none' }}
    >
      <Container
        height="76px"
        width="1006px"
        gradientOverlay={{
          height: '100%',
          width: '100%',
          borderRadius: '16px',
          background:
            'linear-gradient(90deg, rgb(from var(--project-theme-color-primary) r g b / 7%) 0%, var(--global-cont-1) 20%)',
        }}
        className="padding-h-20 flex jc-space-between radius-16 margin-b-24"
      >
        <Container className="flex ai-center jc-space-between width-100-percent">
          <Text className="H4 flex ai-center">
            {projectName} <Text className="H5 margin-h-6">•</Text> {filter.name}
          </Text>
          <Container
            background="rgba(var(--primitives-mode-1-gray-1200-rgb), 0.2)"
            padding="8px 10px"
            className="flex fd-row radius-8"
            style={{ lineHeight: '13px' }}
          >
            <Icon name={ICONS.PEOPLE_NAV} size={13} color="var(--global-ico-text-2)" />
            <Text fontSize="13px" className="margin-l-4" design="GlobalIcoText2">
              {filter.member_count || '-'}
            </Text>
          </Container>
        </Container>
      </Container>
    </NavLink>
  );
};

export default RegistrantFilterCardLarge;
